import axios from 'axios'
import AuiToast from '../../assets/js/aui-toast'

/**
 *  获取项目的所有分组
 * @param {*String} projectId 项目id
 * @returns {Promise<void>}
 */
const getAllGroups = async (projectId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v2/solar-mote-groups?projectId=${projectId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 *  删除分组
 * @param {*String} groupId 分组id
 * @returns {Promise<void>}
 */
const deleteGroup = async (groupId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.delete(`/api/v2/solar-mote-groups/${groupId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}

/**
 * 新增分组
 * @param {*String} options.projectId 所属项目id
 * @param {*String} options.name 分组名称
 * @param {String} options.remark 备注
 */
const createGroup = async (option) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/solar-mote-groups?projectId=${option.projectId}`, option)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取分组内的设备列表
 * @param {*String} groupId 分组id
 */
const getGroupDevices = async (groupId, pageNo, projectId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v2/solar-mote-groups/${groupId}/motes?projectId=${projectId}&pageSize=30&pageNo=${pageNo}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取分组的应用策略
 * @param {*String} groupId 分组id
 */
const getGroupStrategy = async (groupId, type) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  let path = type === '8' || type === '9' ? '-list' : ''
  return axios.get(`/api/v2/solar-mote-strategys/strategy-group${path}/${groupId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 获取单个分组
 * @param {*String} groupId 分组id
 */
const getGroupInfor = async (groupId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.get(`/api/v2/solar-mote-groups/${groupId}`, {})
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 修改分组
 * @param {*String} options.groupId 分组id
 * @param {*String} options.projectId 所属项目id
 * @param {*String} options.name 分组名称
 * @param {String} options.remark 备注
 */
const updataGroupInfor = async (options) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.put(`/api/v2/solar-mote-groups/${options.groupId}`, options)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 更新分组内的设备列表
 * @param {*String} groupId 分组id
 * @param {*Array} deviceId 修改后分组内的设备id列表
 */
const updateInGroup = async (groupId, deviceId) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/device-downs/set-switch-time-strategy-group-mobile/${groupId}`, { solarMoteIds: deviceId })
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 对分组下发策略
 * @param {*String} groupId 分组id
 * @param {*String} strategyId 策略id
 */
const updateGroupStrategy = async (groupId, strategyId, type) => {
  AuiToast.loading({
    title: 'loading...',
    duration: 2000
  }, function (ret) {})
  let strategyTemplate = null
  if (type === '8' || type === '9') {
    strategyTemplate = { strategyTemplateIds: strategyId.split(',') }
  } else {
    strategyTemplate = { strategyTemplateId: strategyId }
  }
  return axios.post(`/api/v2/device-downs/set-strategy-to-group/${groupId}`, strategyTemplate)
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 分组开、关、调光
 * @param {*String} msg 提示文字
 * @param {*String} groupId 分组id
 * @param {*Number} switchState 操作类型，1-开、2-关、3-调光
 * @param {Number} brightness 亮度 调光时，需要该参数
 */
const openOrCloseOrDimmer = async (msg, groupId, switchState, brightness) => {
  AuiToast.loading({
    title: msg,
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/device-downs/switch-control-group/${groupId}`, { switchState, brightness })
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 恒流恒压一体机非LED分组开、关
 * @param {*String} msg 提示文字
 * @param {*String} solarMoteStrategyGroupId 分组id
 * @param {*Number} volSwitchState 操作类型，1-开、0-关
 */
const notLEDOpenOrCloseOrDimmer = async (msg, solarMoteStrategyGroupId, volSwitchState) => {
  AuiToast.loading({
    title: msg,
    duration: 2000
  }, function (ret) {})
  return axios.post(`/api/v2/device-downs/turn-vol-switch-group`, { solarMoteStrategyGroupId, volSwitchState })
    .then(res => {
      AuiToast.hide()
      return res
    })
}
/**
 * 设置充电/不充电，分组下发
 */
const putPowerSwitchGroup = async (msg, projectId, groupId, type) => {
  AuiToast.loading({
    title: msg,
    duration: 2000
  }, function (ret) {})
  return axios.put(`/api/v1/solar-motes/putPowerSwitchGroup?projectId=${projectId}`, { groupId, type })
    .then(res => {
      AuiToast.hide()
      return res
    })
}
const group = {
  getAllGroups,
  deleteGroup,
  createGroup,
  getGroupDevices,
  getGroupStrategy,
  getGroupInfor,
  updataGroupInfor,
  updateInGroup,
  updateGroupStrategy,
  openOrCloseOrDimmer,
  notLEDOpenOrCloseOrDimmer,
  putPowerSwitchGroup
}
export default group
